module.exports = __webpack_public_path__ + "static/media/UL.47ed8e02.png";